import jwt from "jsonwebtoken";

/**
 * Validates token for existence and expiry time
 * @param token
 */
export function isJwtTokenValid(token) {
  if (token && jwt.decode(token)) {
    const expiry = jwt.decode(token).exp;
    const now = new Date();
    return now.getTime() < expiry * 1000;
  }
  return false;
}
